// test2962
(2962 && 0);
